<div class="ib">
  <button type="button" class="ib__btn" (click)="toggle($event)" [attr.aria-label]="i18n.t('inbox.aria')" [class.active]="open()">
    <svg viewBox="0 0 24 24" class="ib__icon" stroke="currentColor" fill="none" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
      <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"></path>
      <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
    </svg>
    @if (unread() > 0) {
      <span class="ib__badge">{{ unread() > 99 ? '99+' : unread() }}</span>
    }
  </button>

  @if (open()) {
    <div class="ib__panel" role="menu">
      <div class="ib__head">
        <span>{{ i18n.t('inbox.title') }}</span>
        @if (unread() > 0) { <span class="ib__count">{{ unread() }} unread</span> }
      </div>
      <div class="ib__body">
        @if (loading()) {
          <div class="ib__empty">{{ i18n.t('common.loading') }}</div>
        } @else if (error()) {
          <div class="ib__empty">{{ i18n.t('inbox.loadFailed') }}</div>
        } @else if (items().length === 0) {
          <div class="ib__empty">{{ i18n.t('inbox.allCaughtUp') }}</div>
        } @else {
          @for (item of items(); track item.id) {
            <button type="button" class="ib__item" [class.unread]="!item.read" (click)="onItemClick(item, $event)">
              <span class="ib__dot" [class.on]="!item.read"></span>
              <span class="ib__main">
                <span class="ib__title">{{ item.title }}</span>
                <span class="ib__text">{{ item.body }}</span>
              </span>
              <span class="ib__time">{{ timeAgo(item.createdAt) }}</span>
            </button>
          }
        }
      </div>
    </div>
  }
</div>
